import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useHeaderFlyoutStore, useHeaderLayoutStore } from '../../../shared';
export function useDesktopMenu() {
  const $ = _c(18);
  const [openMenu, setOpenMenuState] = useState(null);
  const [portalContainer, setPortalContainer] = useState(null);
  const isDesktopMenu = useHeaderLayoutStore(_temp);
  const setFlyoutOpen = useHeaderFlyoutStore(_temp2);
  let t0;
  if ($[0] !== isDesktopMenu || $[1] !== setFlyoutOpen) {
    t0 = function setOpenMenu(value) {
      if (value && !isDesktopMenu) {
        return;
      }
      setOpenMenuState(value);
      setFlyoutOpen("menu", Boolean(value));
    };
    $[0] = isDesktopMenu;
    $[1] = setFlyoutOpen;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setOpenMenu = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = element => {
      setPortalContainer(element?.closest(".header__main-section-sticky") ?? null);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setNavigationRoot = t1;
  let t2;
  let t3;
  if ($[4] !== isDesktopMenu || $[5] !== setFlyoutOpen) {
    t2 = () => {
      if (isDesktopMenu) {
        return;
      }
      setOpenMenuState(null);
      setFlyoutOpen("menu", false);
    };
    t3 = [isDesktopMenu, setFlyoutOpen];
    $[4] = isDesktopMenu;
    $[5] = setFlyoutOpen;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[8] !== setFlyoutOpen) {
    t4 = () => () => setFlyoutOpen("menu", false);
    t5 = [setFlyoutOpen];
    $[8] = setFlyoutOpen;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== setOpenMenu) {
    t6 = () => setOpenMenu(null);
    $[11] = setOpenMenu;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== openMenu || $[14] !== portalContainer || $[15] !== setOpenMenu || $[16] !== t6) {
    t7 = {
      closeMenu: t6,
      openMenu,
      portalContainer,
      setNavigationRoot,
      setOpenMenu
    };
    $[13] = openMenu;
    $[14] = portalContainer;
    $[15] = setOpenMenu;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp2(state_0) {
  return state_0.setFlyoutOpen;
}
function _temp(state) {
  return state.isDesktopMenu;
}